import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReturnedReport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 13,
		cy: 13,
		r: 13,
		fill: "#009BCC"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.4712 8.52876C11.7316 8.78911 11.7316 9.21122 11.4712 9.47157L9.94265 11.0002H15.6665C16.5506 11.0002 17.3984 11.3514 18.0235 11.9765C18.6486 12.6016 18.9998 13.4494 18.9998 14.3335C18.9998 15.2176 18.6486 16.0654 18.0235 16.6905C17.3984 17.3156 16.5506 17.6668 15.6665 17.6668H14.9998C14.6316 17.6668 14.3332 17.3684 14.3332 17.0002C14.3332 16.632 14.6316 16.3335 14.9998 16.3335H15.6665C16.1969 16.3335 16.7056 16.1228 17.0807 15.7477C17.4558 15.3726 17.6665 14.8639 17.6665 14.3335C17.6665 13.8031 17.4558 13.2944 17.0807 12.9193C16.7056 12.5442 16.1969 12.3335 15.6665 12.3335H9.94265L11.4712 13.8621C11.7316 14.1224 11.7316 14.5446 11.4712 14.8049C11.2109 15.0653 10.7888 15.0653 10.5284 14.8049L7.86177 12.1382C7.60142 11.8779 7.60142 11.4558 7.86177 11.1954L10.5284 8.52876C10.7888 8.26841 11.2109 8.26841 11.4712 8.52876Z",
		fill: "white"
	})]
});
export default SvgReturnedReport;
